import script from "./Krediflow-Inbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Krediflow-Inbox.vue?vue&type=script&setup=true&lang=js"

import "./Krediflow-Inbox.vue?vue&type=style&index=0&id=4f93a696&lang=css"
import "./Krediflow-Inbox.vue?vue&type=style&index=1&id=4f93a696&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f93a696"]])

export default __exports__